import { StrategiaDefaultComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-default.component';
import { StrategiaMaterialWartoscComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-material-wartosc.component';
import { StrategiaMaterialWymiaryWartoscComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-material-wymiary-wartosc.component';
import { StrategiaRodzajMaterialWartoscComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-rodzaj-material-wartosc.component';
import { StrategiaWartoscComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-wartosc.component';
import { StrategiaWymiaryComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-wymiary.component';
import {AtrybutyUszkodzen} from './atrybuty-uszkodzen';
import {
  StrategiaIloscComponent
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-ilosc.component';
import {
  StrategiaDodatkowyPrzedmiotComponent
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-dodatkowy-przedmiot.component';
import {
  StrategiaInneComponent
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia-inne.component';
import { StrategiaComponent } from 'src/app/samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/zbior-uszkodzen/uszkodzenie/strategia/strategia.component';
import { Type } from '@angular/core';

export class SlownikUszkodzen {

  protected static Builder = class {
    private readonly slownikUszkodzen: SlownikUszkodzen;

    constructor(nazwa: string, opis: string, priorytetWyswietlania: number, strategiaPodsumowania: Type<StrategiaComponent>) {
      this.slownikUszkodzen = new SlownikUszkodzen(nazwa, opis, priorytetWyswietlania, strategiaPodsumowania);
    }

    domyslnaWartosc(domyslnaWartosc: number): this {
      this.slownikUszkodzen.domyslnaWartosc = domyslnaWartosc;
      return this;
    }

    czyGrupowac(czyGrupowac: boolean): this {
      this.slownikUszkodzen.czyGrupowac = czyGrupowac;
      return this;
    }

    atrybuty(atrybuty: AtrybutyUszkodzen): this {
      this.slownikUszkodzen.atrybuty = atrybuty;
      return this;
    }

    build(): SlownikUszkodzen {
      return this.slownikUszkodzen;
    }
  }

  private static readonly DLUGOSC = 'Długość';
  private static readonly SZEROKOSC = 'Szerokość';
  private static readonly POWIERZCHNIA_USZKODZENIA = 'Powierzchnia uszkodzenia';
  private static readonly INNY_PRZEDMIOT = 'Inny przedmiot';
  private static readonly WYSOKOSC_USZKODZENIA = 'Wysokość uszkodzenia';

  private static readonly pokazWysokoscSzerokoscBezWartosci = new AtrybutyUszkodzen.Builder()
    .pokazWysokosc(true)
    .pokazSzerokosc(true)
    .pokazWartosc(false)
    .build();

  private static readonly pokazWysokoscSzerokoscWartoscEtykiete = new AtrybutyUszkodzen.Builder()
    .pokazWysokosc(true)
    .pokazSzerokosc(true)
    .pokazWartosc(true)
    .etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA)
    .build();

  private static readonly pokazWysokoscSzerokoscFolieReklamowa = new AtrybutyUszkodzen.Builder()
    .pokazWysokosc(true)
    .pokazSzerokosc(true)
    .pokazFolieReklamowa(true)
    .pokazWartosc(false)
    .build();

  public static readonly POKRYCIE_DACHU =
    new SlownikUszkodzen.Builder('POKRYCIE_DACHU', 'Pokrycie dachu', 1, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly GASIORY =
    new SlownikUszkodzen.Builder('GASIORY', 'Gąsiory', 2, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
    .build();
  public static readonly OBROBKI_BLACHARSKIE =
    new SlownikUszkodzen.Builder('OBROBKI_BLACHARSKIE', 'Obróbki blacharskie i kominowe', 3, StrategiaWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly PODBITKA_DACHOWA =
    new SlownikUszkodzen.Builder('PODBITKA_DACHOWA', 'Podbitka dachowa', 4, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly KOMIN =
    new SlownikUszkodzen.Builder('KOMIN', 'Komin', 5, StrategiaWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.WYSOKOSC_USZKODZENIA).build())
      .build();
  public static readonly SUFIT =
    new SlownikUszkodzen.Builder('SUFIT', 'Sufit', 6, StrategiaRodzajMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly SCIANA_WEWNETRZNA =
    new SlownikUszkodzen.Builder('SCIANA_WEW', 'Ściany', 7, StrategiaRodzajMaterialWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
      .build();
  public static readonly SCIANA_ZEWNETRZNA =
    new SlownikUszkodzen.Builder('SCIANA_ZEW', 'Ściana', 8, StrategiaMaterialWymiaryWartoscComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscWartoscEtykiete)
    .build();
  public static readonly PODLOGA =
    new SlownikUszkodzen.Builder('PODLOGA', 'Podłoga', 9, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly LISTWY_PRZYPODLOGOWE =
    new SlownikUszkodzen.Builder('LISTWY_PRZYPODLOGOWE', 'Listwy przypodłogowe', 10, StrategiaWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
      .build();
  public static readonly RYNNY =
    new SlownikUszkodzen.Builder('RYNNY', 'Rynny', 11, StrategiaMaterialWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
      .build();
  public static readonly RURY =
    new SlownikUszkodzen.Builder('RURY', 'Rury spustowe', 12, StrategiaMaterialWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
      .build();
  public static readonly RYNNY_Z_HAKAMI_LACZNIKAMI =
    new SlownikUszkodzen.Builder('RYNNY_Z_HAKAMI_LACZNIKAMI', 'Rynny z hakami i łącznikami', 13, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
    .build();
  public static readonly RURY_Z_HAKAMI_LACZNIKAMI =
    new SlownikUszkodzen.Builder('RURY_Z_HAKAMI_LACZNIKAMI', 'Rury spustowe z hakami i łącznikami', 14, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
    .build();
  public static readonly ZADASZENIE =
    new SlownikUszkodzen.Builder('ZADASZENIE', 'Zadaszenie nad tarasem lub wejściem', 15, StrategiaMaterialWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.POWIERZCHNIA_USZKODZENIA).build())
    .build();
  public static readonly OSZKLENIE_DRZWIOWE =
    new SlownikUszkodzen.Builder('OSZKLENIE_DRZWIOWE', 'Oszklenie drzwiowe', 16, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly SZYBA_KOMINKOWA =
    new SlownikUszkodzen.Builder('SZYBA_KOMINKOWA', 'Szyba żaroodporna kominkowa', 17, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly LUSTRO_STALE =
    new SlownikUszkodzen.Builder('LUSTRO_STALE', 'Lustro zamontowane na stałe', 18, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly LACOBEL =
    new SlownikUszkodzen.Builder('LACOBEL', 'Szklany panel (lacobel)', 19, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly BRODZIK =
    new SlownikUszkodzen.Builder('BRODZIK', 'Brodzik', 20, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly KABINA_PRYSZNICOWA =
    new SlownikUszkodzen.Builder('KABINA_PRYSZNICOWA', 'Kabina prysznicowa', 21, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly MUSZLA_KLOZETOWA = new SlownikUszkodzen.Builder('MUSZLA_KLOZETOWA', 'Muszla klozetowa', 22, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly BIDET =
    new SlownikUszkodzen.Builder('BIDET', 'Bidet', 23, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly UMYWALKA =
    new SlownikUszkodzen.Builder('UMYWALKA', 'Umywalka', 24, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly ZLEWOZMYWAK =
    new SlownikUszkodzen.Builder('ZLEWOZMYWAK', 'Zlewozmywak', 25, StrategiaIloscComponent)
    .domyslnaWartosc(1)
    .atrybuty(new AtrybutyUszkodzen())
    .build();
  public static readonly SKRZYDLO_DRZWIOWE =
    new SlownikUszkodzen.Builder('SKRZYDLO_DRZWIOWE', 'Skrzydło drzwiowe', 26, StrategiaWymiaryComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly OSCIEZNICA_DRZWIOWA =
    new SlownikUszkodzen.Builder('OSCIEZNICA_DRZWIOWA', 'Ościeżnica drzwiowa', 27, StrategiaWymiaryComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly SZYBA_W_DRZWIACH =
    new SlownikUszkodzen.Builder('SZYBA_W_DRZWIACH', 'Szyba w drzwiach', 28, StrategiaWymiaryComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly DRZWI_WEWNETRZNE =
    new SlownikUszkodzen.Builder('DRZWI_WEWNETRZNE', 'Drzwi wewnętrzne (skrzydło + ościeżnica)', 29, StrategiaWymiaryComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly SZYBA_W_OKNIE_PAKIET_DWUSZYBOWY =
    new SlownikUszkodzen.Builder('SZYBA_W_OKNIE_PAKIET_DWUSZYBOWY', 'Szyba w oknie - pakiet dwuszybowy', 30, StrategiaWymiaryComponent)
    .czyGrupowac(true)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly SZYBA_W_OKNIE_PAKIET_TRZYSZYBOWY =
    new SlownikUszkodzen.Builder('SZYBA_W_OKNIE_PAKIET_TRZYSZYBOWY', 'Szyba w oknie - pakiet trzyszybowy', 31, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
      .build();
  public static readonly OGRODZENIE_DREWNO =
    new SlownikUszkodzen.Builder('OGRODZENIE_DREWNO', 'Ogrodzenie drewniane', 32, StrategiaWymiaryComponent)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly OGRODZENIE_SIATKA =
    new SlownikUszkodzen.Builder('OGRODZENIE_SIATKA', 'Ogrodzenie z siatki', 33, StrategiaWartoscComponent)
    .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.SZEROKOSC).build())
    .build();
  public static readonly OGRODZENIE_ZELBETON =
    new SlownikUszkodzen.Builder('OGRODZENIE_ZELBETON', 'Ogrodzenie z prefabrykowanych elementów żelbetonowych', 34, StrategiaWymiaryComponent)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly OGRODZENIE_PANELE =
    new SlownikUszkodzen.Builder('OGRODZENIE_PANELE', 'Ogrodzenie systemowe z paneli metalowych', 35, StrategiaWymiaryComponent)
    .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
    .build();
  public static readonly PLYTA_INDUKCYJNA =
    new SlownikUszkodzen.Builder('PLYTA_INDUKCYJNA', 'Ceramiczna lub indukcyjna płyta kuchenna', 36, StrategiaIloscComponent)
      .domyslnaWartosc(1)
      .atrybuty(new AtrybutyUszkodzen())
      .build();
  public static readonly SZYBA_STOLARKA_DREWNIANA =
    new SlownikUszkodzen.Builder('SZYBA_STOLARKA_DREWNIANA', 'Szyba w stolarce drewnianej zespolona 1-komorowa', 37, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_STOLARKA_ALUMINIOWA =
    new SlownikUszkodzen.Builder('SZYBA_STOLARKA_ALUMINIOWA', 'Szyba w stolarce aluminiowej zespolona 1-komorowa', 38, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_STOLARKA_PCV_1 =
    new SlownikUszkodzen.Builder('SZYBA_STOLARKA_PCV_1', 'Szyba w stolarce PCV zespolona 1-komorowa', 39, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_STOLARKA_PCV_2 =
    new SlownikUszkodzen.Builder('SZYBA_STOLARKA_PCV_2', 'Szyba w stolarce PCV zespolona 2-komorowa', 40, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_ANTYWLAMANIOWA =
    new SlownikUszkodzen.Builder('SZYBA_ANTYWLAMANIOWA', 'Szyba ze szkła antywłamaniowego', 41, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_KULOODPORNA =
    new SlownikUszkodzen.Builder('SZYBA_KULOODPORNA', 'Szyba ze szkła kuloodpornego', 42, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly SZYBA_BEZPIECZNA =
    new SlownikUszkodzen.Builder('SZYBA_BEZPIECZNA', 'Szyba ze szkła bezpiecznego', 43, StrategiaWymiaryComponent)
      .czyGrupowac(true)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscFolieReklamowa)
      .build();
  public static readonly BARIERY_PRZECIWSNIEGOWE =
    new SlownikUszkodzen.Builder('BARIERY_PRZECIWSNIEGOWE', 'Bariery przeciwśniegowe', 44, StrategiaWartoscComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().etykietaWartosci(SlownikUszkodzen.DLUGOSC).build())
      .build();
  public static readonly WYLAZ_DACHOWY =
    new SlownikUszkodzen.Builder('WYLAZ_DACHOWY', 'Wyłaz dachowy', 45, StrategiaIloscComponent)
      .domyslnaWartosc(1)
      .atrybuty(new AtrybutyUszkodzen())
      .build();
  public static readonly SLUPKI_OGRODZENIOWE =
    new SlownikUszkodzen.Builder('SLUPKI_OGRODZENIOWE', 'Słupki ogrodzeniowe (metalowe)', 46, StrategiaIloscComponent)
      .atrybuty(new AtrybutyUszkodzen())
      .build();
  public static readonly BRAMA_FURTKA =
    new SlownikUszkodzen.Builder('BRAMA_FURTKA', 'Brama i/lub furtka', 47, StrategiaWymiaryComponent)
      .atrybuty(SlownikUszkodzen.pokazWysokoscSzerokoscBezWartosci)
      .build();
  public static readonly SZYBA_DO_PIEKARNIKA =
    new SlownikUszkodzen.Builder('SZYBA_DO_PIEKARNIKA', 'Szyba do piekarnika', 48, StrategiaIloscComponent)
      .domyslnaWartosc(1)
      .atrybuty(new AtrybutyUszkodzen())
      .build();
  public static readonly MEBLE =
    new SlownikUszkodzen.Builder('MEBLE', 'Meble', 49, StrategiaDodatkowyPrzedmiotComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().pokazWartosc(false).build())
      .build();
  public static readonly SPRZET_AGD_RTV =
    new SlownikUszkodzen.Builder('SPRZET_AGD_RTV', 'Sprzęt ADD/RTV', 50, StrategiaDodatkowyPrzedmiotComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().pokazWartosc(false).build())
      .build();
  public static readonly INNE =
    new SlownikUszkodzen.Builder('INNE', 'Inny przedmiot', 51, StrategiaInneComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().pokazWartosc(false).pokazKomentarz(true).build())
      .build();
  public static readonly DODATKOWE_PRACE =
    new SlownikUszkodzen.Builder('DODATKOWE_PRACE', 'Dodatkowe prace naprawcze', 52, StrategiaInneComponent)
      .atrybuty(new AtrybutyUszkodzen.Builder().pokazWartosc(false).pokazKomentarz(true).build())
      .build();

  constructor(public nazwa: string,
              public opis: string,
              public priorytetWyswietlania: number,
              public strategiaPodsumowania: Type<StrategiaComponent>,
              public domyslnaWartosc: number | null = null,
              public czyGrupowac: boolean = false,
              public atrybuty?: AtrybutyUszkodzen | undefined) {
  }
}
